<template>
  <Modal>
    <Modal.Media full-bleed>
      <div class="flex justify-center pt-[44px] pb-[18px]">
        <DacrMarkIcon class="size-40 text-gray-800" />
      </div>
    </Modal.Media>
    <Modal.Title>Welcome to Dacr Pro</Modal.Title>
    <Modal.Body>
      Take advantage of all benefits Dacr Pro has to offer. Register your first
      work today.
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="primary" size="lg" @click="close()">Get started</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { DacrMarkIcon } from '@dacr/icons'

const { close } = useModal()
</script>
